import { render, staticRenderFns } from "./RegularTasks.vue?vue&type=template&id=1303f044&"
import script from "./RegularTasks.vue?vue&type=script&lang=js&"
export * from "./RegularTasks.vue?vue&type=script&lang=js&"
import style0 from "./RegularTasks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegularTasks.vue"
export default component.exports